import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {XWaySymbol} from "../../reels/symbols/XWaySymbol";
import {SimpleReelModelSymbolData} from "../../../core/reel/simplereel/SimpleReelModel";
import {BasicSymbol, SymbolStates} from "../../reels/symbols/BasicSymbol";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {NormalSymbol} from "../../reels/symbols/NormalSymbol";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";


export class XWayPresentation implements SimplePresentation {

    name: string = "XWayPresentation";
    private isSkipped: boolean = false;

    shouldRun(): boolean {
        return XwaysHoarder2.model.xwayPos.length > 0 && !XwaysHoarder2.model.checkRespinScenario;
    }

    start(controller: SimplePresentationRunnerController): void {
        this.isSkipped = false;
        const xwsrTl: gsap.core.Timeline = gsap.timeline({
            onStart: () => {
                if (XwaysHoarder2.model.isDefinitelyADeadSpin)
                    xwsrTl.timeScale(2);
            },
            onComplete: () => {
                xwsrTl.timeScale(1);
                controller.setSkipCallback();
                controller.finish();
            }
        });

        // set direction data for normal symbols


        [1, 2, 3, 4, 5].forEach((reelID: number) => {
            [0, 1, 2].forEach((symID: number) => {
                const symData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelID].model.getVisibleSymbolAt(symID);
                const symToExpand: BasicSymbol = <BasicSymbol>symData.positionable;
                if (XwaysHoarder2.model.endSpinHeights[reelID][symID] !== 200 && XwaysHoarder2.model.xwaysCountPerReel[reelID] > 0) {
                    if (XwaysHoarder2Statics.payingSymbols.includes(symToExpand.symbolName)) {
                        (<NormalSymbol>symToExpand).scaleDirection = XwaysHoarder2.model.symbolscaleDirection[reelID][symID];
                    } else if (symToExpand.symbolName === "XW") {
                        (<XWaySymbol>symToExpand).scaleDirection = XwaysHoarder2.model.symbolscaleDirection[reelID][symID];
                    }
                }
            });
        });

        let expandSoundPlayed: boolean = false;
        [1, 2, 3, 4, 5].forEach((reelID: number) => {
            [0, 1, 2].forEach((symID: number) => {
                const symData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelID].model.getVisibleSymbolAt(symID);
                const symToExpand: BasicSymbol = <BasicSymbol>symData.positionable;
                if (XwaysHoarder2.model.endSpinHeights[reelID][symID] !== 200 && XwaysHoarder2.model.xwaysCountPerReel[reelID] > 0) {
                    const expandTl: gsap.core.Timeline = gsap.timeline();
                    expandTl.add(symToExpand.getStateAnimation(SymbolStates.SCALED));
                    if(!expandSoundPlayed) {
                        expandTl.add(() => {
                            if(XwaysHoarder2.model.isDefinitelyADeadSpin) {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XWAY_EXPAND_FAST);
                            }
                            else {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XWAY_EXPAND);
                            }
                        }, "<");
                        expandSoundPlayed = true;
                    }
                    xwsrTl.add(expandTl, 0);

                }
            });
        });

        xwsrTl.addLabel("postScale");

        [1, 2, 3, 4, 5].forEach((reelID: number) => {
            [0, 1, 2].forEach((symID: number) => {
                const symData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelID].model.getVisibleSymbolAt(symID);
                if (symData.name === "XW") {
                    const xwSym: XWaySymbol = <XWaySymbol>symData.positionable;
                    const revealTl: gsap.core.Timeline = gsap.timeline();

                    // anticipation padding for loot respins reveal
                    let startPadding = "";
                    if (XwaysHoarder2.model.data.mode == GameMode.RESPIN) {
                        const flatArray = XwaysHoarder2.model.gameData.reels.reduce((a, b) => a.concat(b), []);
                        const hasXWays = flatArray.some((sym) => sym == "XW");
                        const featureCount = flatArray.filter((sym) => sym == "XW" || sym == "XS").length;
                        if (featureCount > 6)
                            startPadding = ">1.5";
                        if (featureCount > 4)
                            startPadding = ">0.75";
                        if (featureCount > 2)
                            startPadding = ">0.5";
                    }

                    revealTl.add(xwSym.getStateAnimation(SymbolStates.REVEAL), startPadding);
                    xwsrTl.add(revealTl, "postScale");

                }
            });
        });



        controller.setSkipCallback(() => this.xwaysSkip(xwsrTl));
    }

    private xwaysSkip(tl: gsap.core.Timeline) {
        if (!this.isSkipped) {
            this.isSkipped = true;
            if(XwaysHoarder2Sound.soundPlayer.fetchSoundPlayer(XwaysHoarder2Sound.XWAY_EXPAND)?.isPlaying){
                XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.XWAY_EXPAND);
            }
            if(XwaysHoarder2Sound.soundPlayer.fetchSoundPlayer(XwaysHoarder2Sound.XWAY_EXPAND_FAST)?.isPlaying){
                XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.XWAY_EXPAND_FAST);
            }
            tl.totalProgress(1);
        }
    }
}